import Authority from "../reusables/Authority";

const HomeHero = () => {
  return (
    <section className="hero relative">
      <div className="container">
        <div className="large">
          <div className="section-content-container hero-content-container">
            <div className="hero-brand-container flex">
              <div className="hero-text-side">
                <div className="hero-text-container">
                  <span className="proof">
                    Proven International Web & ICT Solutions Provider
                    <sup className="left-pull-4">&trade;</sup>
                  </span>

                  <h1>Reliable Web & ICT Solutions for Growing Businesses</h1>

                  <ul className="font-inter-regular ">
                    <li>
                      <span className="ntuna-coral">✔︎ </span>
                      <span className="hero-solution-list-item">
                        Website, systems & app development
                      </span>
                    </li>
                    <li>
                      <span className="ntuna-coral">✔︎ </span>
                      <span className="hero-solution-list-item">
                        Digital marketing & branding
                      </span>
                    </li>
                    <li>
                      <span className="ntuna-coral">✔︎ </span>
                      <span className="hero-solution-list-item">
                        ICT consultancy & equipment supply
                      </span>
                    </li>
                    <li>
                      <span className="ntuna-coral">✔︎ </span>
                      <span className="hero-solution-list-item">
                        School lab & office ICT setup
                      </span>
                    </li>
                    <li>
                      <span className="ntuna-coral">✔︎ </span>
                      <span className="hero-solution-list-item">
                        CCTV Installation, IT security & networking
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="hero-cta-container flex">
                  <a
                    href="https://form.jotform.com/ntuna/get-free-quote"
                    className="button main-cta hero-cta slide-in-down"
                  >
                    Get Free Quote
                  </a>
                  <a
                    href="/case-studies"
                    className="button sub-cta hero-cta slide-in-down"
                  >
                    Case Studies
                  </a>
                </div>
              </div>
              <div className="hero-image-side slide-in-down">
                <img
                  src="https://res.cloudinary.com/malidad/image/upload/v1777811420/ntuna/office-500_tr7ja8.jpg"
                  className="box-shadow"
                  alt="NTUNA.COM Workplace"
                />
              </div>
            </div>
            <Authority />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
